module.exports = {
  "Yes": "Ya",
  "Male": "Lelaki",
  "Female": "Perempuan",
  "Other": "Lain-lain",
  "Non": "Bukan",
  "Spouse": "Pasangan",
  "Child": "Anak",
  "husband": "Suami",
  "brother": "Abang/Adik Lelaki",
  "sister": "Kakak/Adik Perempuan",
  "grandfather": "Datuk",
  "grandmother": "Nenek",
  "grandson": "Cucu Lelaki",
  "granddaughter": "Cucu Perempuan",
  "uncle": "Bapa Saudara",
  "aunt": "Ibu Saudara",
  "nephew": "Anak Saudara Lelaki",
  "niece": "Anak Saudara Perempuan",
  "cousin": "Sepupu",
  "friend": "Kawan",
  "Monthly": "Bulanan",
  "Yearly": "Tahunan",
  "Security": "Keselamatan",
  "and": "dan",
  "Sub": "Sub",
  "Admin": "Pentadbir",
  "Comment": "Komen",
  "Description": "Penerangan",
  "See": "Lihat",
  "Make": "Buat",
  "ON": "HIDUP",
  "Amount": "Jumlah",
  "Added": "Ditambah",
  "Successfully": "Berjaya",
  "Updated": "Dikemaskini",
  "Your": "Anda",
  "Form": "Borang",
  "form": "borang",
  "is": "adalah",
  "submitted": "dihantar",
  "Manage": "Urus",
  "marked": "ditanda",
  "with": "dengan",
  "are": "adalah",
  "required": "diperlukan",
  "Hourly": "Setiap Jam",
  "Weekly": "Mingguan",
  "OK": "OK",
  "Complaint": "Aduan",
  "From": "Daripada",
  "Subject": "Subjek",
  "Category": "Kategori",
  "Number of Days Outstanding": "Bilangan Hari Tertunggak",
  "Open": "Buka",
  "Are you sure?": "Adakah anda pasti?",
  "that you want to delete this record?": "bahawa anda mahu memadam rekod ini?",
  "Deleted": "Dipadam",
  "View": "Lihat",
  "Against": "Terhadap",
  "Uploaded": "Dimuat Naik",
  "Taken": "Diambil",
  "Attendance": "Kehadiran",
  "In-Time": "Masa Masuk",
  "Out-Time": "Masa Keluar",
  "Total": "Jumlah",
  "Work": "Kerja",
  "Time": "Masa",
  "Break": "Rehat",
  "Are you sure that you want to edit this record which done by hr admin?": "Adakah anda pasti mahu mengedit rekod ini yang dibuat oleh admin HR?",
  "Are you sure that you want to edit this record which done by employee login?": "Adakah anda pasti mahu mengedit rekod ini yang dibuat oleh log masuk pekerja?",
  "Deleted Successfully": "Berjaya Dipadam",
  "Archived": "Diarkibkan",
  "Check In Radius Check": "Semakan Radius Daftar Masuk",
  "Check Out Radius Check": "Semakan Radius Daftar Keluar",
  "Done By HR ADMIN": "Dilakukan Oleh ADMIN HR",
  "Write reason of delete:": "Tulis alasan pemadaman:",
  "ADD": "TAMBAH",
  "Hrs": "Jam",
  "Min": "Min",
  "Enter Rest Time as Hrs:Min": "Masukkan Masa Rehat sebagai Jam:Min",
  "Enter Early Leaving as Hrs:Min": "Masukkan Keluar Awal sebagai Jam:Min",
  "Please enter In time": "Sila masukkan masa Masuk",
  "Please enter Out time": "Sila masukkan masa Keluar",
  "Can not Add Attendance": "Tidak dapat Tambah Kehadiran",
  "YYYY-MM-DD": "TTTT-BB-HH",
  "All fields marked with * are required": "Semua ruangan bertanda * adalah wajib",
  "Positions": "Jawatan",
  "Departments": "Jabatan",
  "Actual": "Sebenar",
  "Reason": "Alasan",
  "Can not Add Privilege": "Tidak dapat Tambah Keistimewaan",
  "Can not Edit Privilege": "Tidak dapat Edit Keistimewaan",
  "Can not Delete Privilege": "Tidak dapat Padam Keistimewaan",
  "Pending": "Menunggu",
  "Approved": "Diluluskan",
  "Rejected": "Ditolak",
  "Please": "Sila",
  "Check Your Leave Bank": "Semak Baki Cuti Anda",
  "From Date should not be greater than To Date": "Tarikh Mula tidak boleh lebih besar daripada Tarikh Tamat",
  "Please add leave templete for this employee ": "Sila tambah templat cuti untuk pekerja ini",
  "Leave present at this date": "Cuti wujud pada tarikh ini",
  "can": "boleh",
  "not": "tidak",
  "Start": "Mula",
  "End": "Tamat",
  "Duration": "Tempoh",
  "Starts in first half": "Bermula pada separuh masa pertama",
  "Starts in second half": "Bermula pada separuh masa kedua",
  "Full Day Leave": "Cuti Sepenuh Hari",
  "Post Edit Remark": "Nota Selepas Edit",
  "Attachment": "Lampiran",
  "Staff": "Kakitangan",
  "Staffs": "Kakitangan",
  "Exists": "Wujud",
  "Not": "Bukan",
  "Found": "Dijumpai",
  "Any": "Mana-mana",
  "App": "Aplikasi",
  "URL": "URL",
  "Go to App Url": "Pergi ke URL Aplikasi",
  "Created At": "Dicipta Pada",
  "Announcement": "Pengumuman",
  "Announcements": "Pengumuman",
  "Success": "Berjaya",
  "Available": "Tersedia",
  "Model": "Model",
  "Asset": "Aset",
  "Assigned": "Ditugaskan",
  "Issue On": "Dikeluarkan Pada",
  "Sr": "No.",
  "Please Start the camera": "Sila mulakan kamera",
  "Please add the image": "Sila tambah imej",
  "Your last Checked out": "Daftar keluar terakhir anda",
  "Bulk Import Failed": "Import Pukal Gagal",
  "in": "dalam",
  "Sample": "Sampel",
  "CSV": "CSV",
  "File": "Fail",
  "Upload": "Muat Naik",
  "You must set location allow": "Anda mesti membenarkan akses lokasi",
  "Check Inout": "Daftar Masuk/Keluar",
  "Submit": "Hantar",
  "Retry": "Cuba Lagi",
  "You already Checked In": "Anda sudah Daftar Masuk",
  "Check In": "Daftar Masuk",
  "Check Out": "Daftar Keluar",
  "Latitude": "Latitud",
  "Longitude": "Longitud",
  "List": "Senarai",
  "Employees": "Pekerja",
  "Dashboard": "Papan Pemuka",
  "Select": "Pilih",
  "Organization": "Organisasi",
  "Status": "Status",
  "Department": "Jabatan",
  "Position": "Jawatan",
  "Export": "Eksport",
  "Import": "Import",
  "Update": "Kemaskini",
  "Qrcode": "Kod QR",
  "Search": "Cari",
  "No": "Tidak",
  "New": "Baru",
  "Complaints": "Aduan",
  "Information": "Maklumat",
  "Employee": "Pekerja",
  "Email": "Emel",
  "Mobile": "Telefon Bimbit",
  "Action": "Tindakan",
  "Add": "Tambah",
  "Edit": "Edit",
  "Basic": "Asas",
  "Info": "Info",
  "Leaves": "Cuti",
  "Points": "Mata",
  "Documents": "Dokumen",
  "Assets": "Aset",
  "Salary": "Gaji",
  "Note": "Nota",
  "Payslips": "Slip Gaji",
  "Emergency": "Kecemasan",
  "Contacts": "Kenalan",
  "First": "Pertama",
  "Name": "Nama",
  "ID": "ID",
  "Last": "Terakhir",
  "Middle": "Tengah",
  "Address": "Alamat",
  "Gender": "Jantina",
  "Date": "Tarikh",
  "Of": "daripada",
  "Birth": "Lahir",
  "Timezone": "Zon Masa",
  "Location": "Lokasi",
  "Long": "Panjang",
  "Lat": "Lat",
  "Restrict": "Sekat",
  "CheckIn": "Daftar Masuk",
  "Radius": "Radius",
  "CheckOut": "Daftar Keluar",
  "Nationality": "Kewarganegaraan",
  "Resident": "Penduduk",
  "Shift": "Sif",
  "Group": "Kumpulan",
  "JD": "Huraian Kerja",
  "Title": "Tajuk",
  "Access": "Akses",
  "UserType": "Jenis Pengguna",
  "QR": "QR",
  "Download": "Muat Turun",
  "Cancel": "Batal",
  "Enter": "Masukkan",
  "Password": "Kata Laluan",
  "In-Active": "Tidak Aktif",
  "Dependent": "Tanggungan",
  "Relation": "Hubungan",
  "Present": "Hadir",
  "Age": "Umur",
  "Save": "Simpan",
  "changes": "perubahan",
  "Leave": "Cuti",
  "Template": "Templat",
  "Current": "Semasa",
  "Balance": "Baki",
  "Allowed": "Dibenarkan",
  "Negative": "Negatif",
  "Transaction": "Transaksi",
  "History": "Sejarah",
  "Manual": "Manual",
  "Credit": "Kredit",
  "Debit": "Debit",
  "Close": "Tutup",
  "Frequency": "Kekerapan",
  "Quantity": "Kuantiti",
  "Paycode": "Kod Gaji",
  "Type": "Jenis",
  "Opening": "Pembukaan",
  "All": "Semua",
  "Document": "Dokumen",
  "Days": "Hari",
  "to": "ke",
  "Already": "Sudah",
  "Expired": "Tamat Tempoh",
  "Expiry": "Tarikh Tamat",
  "Remark": "Catatan",
  "Declaration": "Pengisytiharan",
  "Issue": "Isu",
  "Return": "Kembali",
  "Allowance": "Elaun",
  "Code": "Kod",
  "Taxable": "Tertakluk Cukai",
  "tax": "cukai",
  "Telephone": "Telefon",
  "Distance": "Jarak",
  "Check out details are Not Available": "Butiran daftar keluar tidak tersedia",
  "Details": "Butiran",
  "Get": "Dapatkan",
  "Image": "Imej",
  "This entry is generated by Admin": "Entri ini dijana oleh Admin",
  "for": "untuk",
  "CheckInOut": "MasukKeluar",
  "enter": "masuk",
  "Email ID": "ID Emel",
  "password": "kata laluan",
  "Incorrect": "Salah",
  "Credentials": "Kredential",
  "Login": "Log Masuk",
  "Unsuccessful": "Tidak Berjaya",
  "Forgot": "Lupa",
  "Sign Up Now": "Daftar Sekarang",
  "Sign in": "Log Masuk",
  "Banner": "Sepanduk",
  "Size": "Saiz",
  "Sequence": "Urutan",
  "Publish": "Terbitkan",
  "Blog": "Blog",
  "Blogs": "Blog",
  "Draft": "Draf",
  "Unpublished": "Tidak Diterbitkan",
  "Published": "Diterbitkan",
  "type": "jenis",
  "Video": "Video",
  "Back to": "Kembali ke",
  "Chapters": "Bab",
  "Chapter": "Bab",
  "Topics": "Topik",
  "Under this": "Di bawah ini",
  "Course": "Kursus",
  "PDF": "PDF",
  "VIDEO": "VIDEO",
  "Topic": "Topik",
  "Involved": "Terlibat",
  "By": "Oleh",
  "Welcome back": "Selamat kembali",
  "Data": "Data",
  "For": "Untuk",
  "From Date": "Dari Tarikh",
  "To Date": "Hingga Tarikh",
  "TODAY'S": "HARI INI",
  "ATTENDANCE": "KEHADIRAN",
  "THIS": "INI",
  "MONTH": "BULAN",
  "LEAVE": "CUTI",
  "TOTAL": "JUMLAH",
  "ORGANIZATIONS": "ORGANISASI",
  "ACTIVE": "AKTIF",
  "EMPLOYEES": "PEKERJA",
  "Today's": "Hari Ini",
  "Project Head": "Ketua Projek",
  "Contact No": "No. Hubungan",
  "Add More": "Tambah Lagi",
  "Guest": "Tetamu",
  "Visit To": "Melawat Ke",
  "License Plate": "No. Plat Kenderaan",
  "Add Checkout Time": "Tambah Masa Daftar Keluar",
  "Business Visit": "Lawatan Perniagaan",
  "Meeting": "Mesyuarat",
  "Personal Visit": "Lawatan Peribadi",
  "Interview": "Temu Duga",
  "Presentation": "Pembentangan",
  "Sales Visit": "Lawatan Jualan",
  "Client Visit": "Lawatan Pelanggan",
  "Supplier Visit": "Lawatan Pembekal",
  "Take": "Ambil",
  "HR": "HR",
  "Email Already Exists": "Emel Sudah Wujud",
  "HR Code Already Exists": "Kod HR Sudah Wujud",
  "Account Name Already Exists": "Nama Akaun Sudah Wujud",
  "Account Name should not be greater than 10 characters": "Nama akaun tidak boleh melebihi 10 aksara",
  "Database not found with given account name, Please create database first": "Pangkalan data tidak dijumpai dengan nama akaun yang diberikan, Sila cipta pangkalan data dahulu",
  "Database not available to create HR admin": "Pangkalan data tidak tersedia untuk mencipta admin HR",
  "Min.Amount": "Jumlah Min.",
  "Max.Amount": "Jumlah Maks.",
  "Base amount": "Jumlah Asas",
  "Percentage": "Peratusan",
  "Tax": "Cukai",
  "Dependence Allowance": "Elaun Tanggungan",
  "Tax Bracket List": "Senarai Kurungan Cukai",
  "Tax Bracket": "Kurungan Cukai",
  "Super User": "Pengguna Super",
  "Day": "Hari",
  "Monday": "Isnin",
  "Rest-Time": "Masa Rehat",
  "tuesday": "Selasa",
  "Wednesday": "Rabu",
  "Thursday": "Khamis",
  "Friday": "Jumaat",
  "Saturday": "Sabtu",
  "Sunday": "Ahad",
  "Signup": "Daftar",
  "Requests": "Permintaan",
  "Reference": "Rujukan",
  "Account": "Akaun",
  "Personal": "Peribadi",
  "Create": "Cipta",
  "user Roles": "Peranan Pengguna",
  "Task": "Tugasan",
  "In Progress": "Dalam Proses",
  "Completed": "Selesai",
  "Logs Present in this Task so cant be deleted": "Log wujud dalam tugasan ini maka tidak boleh dipadam",
  "Log Text": "Teks Log",
  "Logs": "Log",
  "Projects": "Projek",
  "Member": "Ahli",
  "Moderate": "Sederhana",
  "Low": "Rendah",
  "High": "Tinggi",
  "Very High": "Sangat Tinggi",
  "Priority": "Keutamaan",
  "Visit": "Lawatan",
  "Weight": "Berat",
  "Value": "Nilai",
  "Score": "Skor",
  "Completion": "Penyelesaian",
  "Uploaded image has not valid Height and Width": "Imej yang dimuat naik tidak mempunyai Tinggi dan Lebar yang sah",
  "Promotion": "Promosi",
  "Redirect": "Hala Semula",
  "Task Presnt in this Project so cant be deleted": "Tugasan wujud dalam projek ini maka tidak boleh dipadam",
  "Now": "Sekarang",
  "Importance": "Kepentingan",
  "Performance Kpi": "KPI Prestasi",
  "Please add the reason of delete": "Sila tambah alasan pemadaman",
  "Role": "Peranan",
  "Please select at least one module": "Sila pilih sekurang-kurangnya satu modul",
  "Analyst": "Penganalisis",
  "analytics": "Analitik",
  "Top Selling": "Paling Laris",
  "Shop": "Kedai",
  "Cart": "Troli",
  "File size less than 1 MB": "Saiz fail kurang daripada 1 MB",
  "Check Discount Price": "Semak Harga Diskaun",
  "Required": "Diperlukan",
  "Investigating": "Menyiasat",
  "Incident": "Insiden",
  "Job": "Kerja",
  "Level": "Tahap",
  "Grade": "Gred",
  "Attach": "Lampir",
  "Functions": "Fungsi",
  "Qualification": "Kelayakan",
  "Responsibilities": "Tanggungjawab",
  "Reporting": "Pelaporan",
  "Perks": "Faedah Sampingan",
  "Benefits": "Manfaat",
  "Make-Model": "Buat-Model",
  "Check IN/OUT": "Daftar MASUK/KELUAR",
  "Please Upload the File": "Sila Muat Naik Fail",
  "No mid month": "Tiada pertengahan bulan",
  "Mid Month": "Pertengahan Bulan",
  "Payroll": "Penggajian",
  "Process": "Proses",
  "Bonus": "Bonus",
  "Working": "Bekerja",
  "Test": "Ujian",
  "Live": "Langsung",
  "Line": "Baris",
  "Entry": "Kemasukan",
  "Currency": "Mata Wang",
  "Rate": "Kadar",
  "Banners": "Sepanduk",
  "Orders": "Pesanan",
  "Product": "Produk",
  "Pay Codes": "Kod Gaji",
  "Comments": "Komen",
  "Career": "Kerjaya",
  "Profile": "Profil",
  "Employee Presence": "Kehadiran Pekerja",
  "Employee Absence": "Ketidakhadiran Pekerja",
  "My Job Description": "Huraian Kerja Saya",
  "Job Description": "Huraian Kerja",
  "Settings": "Tetapan",
  "Public Holidays": "Cuti Umum",
  "Master Department": "Induk Jabatan",
  "Point Declaration": "Pengisytiharan Mata",
  "User Role": "Peranan Pengguna",
  "Admin Apps": "Aplikasi Admin",
  "Groups": "Kumpulan",
  "Employee Bulk Import": "Import Pukal Pekerja",
  "Guests": "Tetamu",
  "Check In Out": "Daftar Masuk Keluar",
  "Incident Report": "Laporan Insiden",
  "Tasks": "Tugasan",
  "Work Plan": "Pelan Kerja",
  "My": "Saya",
  "Promotions": "Promosi",
  "Payroll Line Entry": "Kemasukan Baris Gaji",
  "Employee Chat": "Sembang Pekerja",
  "Messages": "Mesej",
  "Training": "Latihan",
  "SignUp Requests": "Permintaan Daftar",
  "My Profile": "Profil Saya",
  "Employee Career": "Kerjaya Pekerja",
  "Job Post": "Iklan Kerja",
  "Application List": "Senarai Permohonan",
  "Job Frontend Url": "URL Hadapan Kerja",
  "Manage Shifts": "Urus Sif",
  "Shift Scheduler": "Penjadual Sif",
  "Shift Scheduler History": "Sejarah Penjadual Sif",
  "Shift Schedule": "Jadual Sif",
  "Constants": "Pemalar",
  "No Preference": "Tiada Keutamaan",
  "Fresher": "Lepasan Baru",
  "Year": "Tahun",
  "Short Description": "Penerangan Ringkas",
  "Long Description": "Penerangan Panjang",
  "Add Thumbnail Image": "Tambah Imej Kecil",
  "Enter Valid link": "Masukkan pautan sah",
  "In Stock": "Dalam Stok",
  "Out Of Stock": "Habis Stok",
  "In Active": "Dalam Aktif",
  "Ordered": "Dipesan",
  "Accepted": "Diterima",
  "Rejected and Closed": "Ditolak dan Ditutup",
  "Shipped/InTransit": "Dihantar/Dalam Transit",
  "Completed and Closed": "Selesai dan Ditutup",
  "Cancelled and Closed": "Dibatalkan dan Ditutup",
  "Order No": "No. Pesanan",
  "Order On": "Pesanan Pada",
  "Product Feature": "Ciri Produk",
  "Subtotal": "Subjumlah",
  "No items in the cart": "Tiada item dalam troli",
  "Place Order": "Buat Pesanan",
  "Change": "Tukar",
  "Language": "Bahasa",
  "Job Title": "Tajuk Jawatan",
  "All Employee": "Semua Pekerja",
  "Day Leave": "Cuti Hari",
  "System Logs": "Log Sistem",
  "Employee Documents": "Dokumen Pekerja",
  "Leave Types": "Jenis Cuti",
  "Allowance Type": "Jenis Elaun",
  "Allowance Code": "Kod Elaun",
  "Note Code": "Kod Nota",
  "Document Code": "Kod Dokumen",
  "Comment Category": "Kategori Komen",
  "Comment Type": "Jenis Komen",
  "My Shift Schedule": "Jadual Sif Saya",
  "My Orders": "Pesanan Saya",
  "Organization Blogs": "Blog Organisasi",
  "My Attendance": "Kehadiran Saya",
  "My Leaves": "Cuti Saya",
  "Access Code": "Kod Akses",
  "My Points": "Mata Saya",
  "My Documents": "Dokumen Saya",
  "My Assests": "Aset Saya",
  "My Payslips": "Slip Gaji Saya",
  "Sub Admin": "Sub Admin",
  "Manage Tax Brackets": "Urus Kurungan Cukai",
  "All Shifts": "Semua Sif",
  "Shift Scheduler Import": "Import Penjadual Sif",
  "Project Task": "Tugasan Projek",
  "Employee Training": "Latihan Pekerja",
  "Employee Shop": "Kedai Pekerja",
  "Product Category": "Kategori Produk",
  "Products": "Produk",
  "Public Holiday": "Cuti Umum",
  "Blog Type": "Jenis Blog",
  "Job Type": "Jenis Kerja",
  "Course Type": "Jenis Kursus",
  "Annoucement Type": "Jenis Pengumuman",
  "Add/Subtract": "Tambah/Tolak",
  "Mood": "Mood",
  "Negative Balance": "Baki Negatif",
  "Leave Bank Report": "Laporan Bank Cuti",
  "Payroll Type": "Jenis Penggajian",
  "Flat Salary": "Gaji Tetap",
  "Salary Attendance": "Kehadiran Gaji",
  "Salary Attendance + OT": "Kehadiran Gaji + OT",
  "Hourly Wages": "Upah Sejam",
  "Deduction": "Potongan",
  "Adjustment": "Pelarasan",
  "Settlements": "Penyelesaian",
  "Current Balance": "Baki Semasa",
  "Allowed Negative Balance": "Baki Negatif Dibenarkan",
  "No Record Found": "Tiada Rekod Dijumpai",
  "Upcoming": "Akan Datang",
  "Absent": "Tidak Hadir",
  "Apply": "Mohon",
  "Database Host": "Hos Pangkalan Data",
  "Database User": "Pengguna Pangkalan Data",
  "Database Password": "Kata Laluan Pangkalan Data",
  "Primary Database Name": "Nama Pangkalan Data Utama",
  "Payroll Database Name": "Nama Pangkalan Data Gaji",
  "Language Translation Type": "Jenis Terjemahan Bahasa",
  "Google Transaltor": "Penterjemah Google",
  "Custom": "Tersuai",
  "Default Language": "Bahasa Lalai",
  "English": "Inggeris",
  "Khemer": "Khmer",
  "Chinese": "Cina",
  "More than 1 organization cannot be added": "Lebih daripada 1 organisasi tidak boleh ditambah",
  "Organization Code already exists": "Kod organisasi sudah wujud",
  "Add Payslip Header or Footer or organization logo": "Tambah Kepala atau Kaki Slip Gaji atau logo organisasi",
  "Company Policy": "Dasar Syarikat",
  "Employee Handbook": "Buku Panduan Pekerja",
  "Payslip Header": "Kepala Slip Gaji",
  "Payslip Footer": "Kaki Slip Gaji",
  "Color Code": "Kod Warna",
  'Shifts': 'Sif',
  "Visitor": "Pelawat",
  "Work Scheduler": "Penjadual Kerja",
  "Work Scheduler History": "Sejarah Penjadual Kerja",
  "Work Scheduler Import": "Import Penjadual Kerja",
  "Vehicle": "Kenderaan",
  "Total IN Visitor": "Jumlah Pelawat Masuk",
  "Seniority Pay": "Bayaran Senioriti",
  "Convert to USD Dollar": "Tukar ke Dollar USD",
  "Expire With In Days": "Tamat Tempoh Dalam Beberapa Hari",
  "Sign out": "Log Keluar",
  "Outstanding": "Cemerlang",
  "Leave Bank": "Bank Cuti",
  "Settlement Import": "Import Penyelesaian",
  "Tax Code": "Kod Cukai",
  "Business Promotions": "Promosi Perniagaan",
  "HR Blog": "Blog HR",
  "Job Discloursere": "Pendedahan Kerja",
  "Payroll Headers": "Kepala Penggajian",
  "Settlement Type": "Jenis Penyelesaian",
  "Settlement Code": "Kod Penyelesaian",
  "Document Types": "Jenis Dokumen",
  "Employee Groups": "Kumpulan Pekerja",
  "Job ID": "ID Kerja",
  "Payroll Privilege": "Keistimewaan Penggajian",
  "To": "Kepada",
  "options": "pilihan",
  "General": "Umum",
  "Very Sad": "Sangat Sedih",
  "Sad": "Sedih",
  "Just OK": "Biasa Sahaja",
  "Good": "Baik",
  "Fantastic": "Hebat",
  "zone": "zon",
  "Rest": "Rehat",
  "NOTE:In Time and Out Time in 24 Hrs Format": "NOTA: Masa Masuk dan Keluar dalam Format 24 Jam",
  "Early Out": "Keluar Awal",
  "Over Time": "Kerja Lebih Masa",
  "Late In": "Masuk Lewat",
  "Previous": "Sebelumnya",
  "Records": "Rekod",
  "Check IN Out Records": "Rekod Daftar Masuk Keluar",
  "Check IN": "Daftar Masuk",
  "Check": "Semak",
  "Owner": "Pemilik",
  "Address Line": "Baris Alamat",
  "City": "Bandar",
  "State/Province": "Negeri/Provinsi",
  "Country": "Negara",
  "Attendance Radius (in Meters)": "Radius Kehadiran (dalam Meter)",
  "Height": "Tinggi",
  "Width": "Lebar",
  "ID Template": "Templat ID",
  "Logo": "Logo",
  "Active": "Aktif",
  "Approved/In-Active": "Diluluskan/Tidak Aktif",
  "Write reason of": "Tulis alasan untuk",
  "Are you sure that you want to In-Active this record?": "Adakah anda pasti mahu menyahaktifkan rekod ini?",
  "Profile Image": "Imej Profil",
  "Notice Pay": "Bayaran Notis",
  "Local Name": "Nama Tempatan",
  "expire": "tamat tempoh",
  "Settlement": "Penyelesaian",
  "NOTE: In Time and Out Time in 24 Hrs Format": "NOTA: Masa Masuk dan Keluar dalam Format 24 Jam",
  "Tuesday": "Selasa",
  "Pay Code": "Kod Gaji",
  "Scheduler": "Penjadual",
  "Calender View": "Paparan Kalendar",
  "Download Sample File": "Muat Turun Fail Sampel",
  "Download Sample CSV File": "Muat Turun Fail CSV Sampel",
  "Preview Of Shift Scheduler Table": "Pratonton Jadual Penjadual Sif",
  "Shift Scheduler of Parent Table": "Penjadual Sif bagi Jadual Induk",
  "Preview": "Pratonton",
  "Full Month": "Bulan Penuh",
  "System": "Sistem",
  "Approval": "Kelulusan",
  "Payslip": "Slip Gaji",
  "Designation": "Jawatan",
  "Multiplier": "Pengganda",
  "Project": "Projek",
  "Members": "Ahli",
  "Analytics": "Analitik",
  "Payment": "Pembayaran",
  "Approve": "Lulus",
  "Hours": "Jam",
  "Maternal": "Bersalin",
  "Adjustment": "Pelarasan",
  "OT": "OT",
  "Paycodes": "Kod Gaji",
  "Left": "Kiri",
  "Joining":"Menyertai",
  "Hiring":"Pengambilan",
  "Application":"Permohonan",
  "Emergancy":"Kecemasan",
  "Contact":"Hubungan",
  "Print":"Cetak",
  "Not Consider In Payroll":"Tidak Diambil Kira Dalam Penggajian",
  "Sequence No":"No. Urutan",
  "Special":"Khas",
  "Report":"Laporan",
  "Summary":"Ringkasan",
  "Out":"Keluar",
  "Link":"Pautan",
  "Url":"Url",
  "CV":"CV",
  "LinkedIn":"LinkedIn",
  "Final":"Akhir",
  "Open Payslips":"Buka Slip Gaji",
  "Close Payslips":"Tutup Slip Gaji",
  "Reports":"Laporan",
  "Payroll Reports":"Laporan Penggajian",
  "Notice Pay Reports":"Laporan Bayaran Notis",
  "Staff IN OUT Reports":"Laporan Masuk Keluar Kakitangan",
  "Leave Reports":"Laporan Cuti",
  "Paid":"Dibayar",
  "Bank":"Bank",
  "Evaluated":"Dinilai",
  'Obtained':'Diperoleh',
  "OneTime":"Sekali Sahaja",
  "Daily":"Harian",
  "HH:MM":"JJ:MM",
  "Base Amount":"Jumlah Asas",
  "Month":"Bulan",
  "Date Range":"Julat Tarikh",
  "Staffing":"Kakitangan",
  "Requirement":"Keperluan",
  "Anyalsis":"Analisis",
  "Privious":"Sebelumnya",
  "Budget":"Bajet",
  "To Hire":"Untuk Diambil Bekerja",
  "Work Plan/KPI":"Pelan Kerja / KPI",
  "KPI":"KPI",
  "Employee Evalution":"Penilaian Pekerja",
  "KPI Project":"Projek KPI",
  "Detail":"Butiran",
  "Complete":"Selesai",
  "Performance":"Prestasi",
  "Achieved":"Dicapai",
  "Improvement":"Penambahbaikan",
  "Core":"Teras",
  "Job Disclosure":"Pendedahan Kerja",
  "Post":"Iklan",
  "Employee List":"Senarai Pekerja",
  "Notice Pay Check":"Semakan Bayaran Notis",
  "My Work Schedule":"Jadual Kerja Saya",
  "Employee ID":"ID Pekerja",
  "QR Code":"Kod QR",
  "IDCard":"Kad ID",
  "Record Added Successfully":"Rekod Berjaya Ditambah",
  "Record Updated Successfully":"Rekod Berjaya Dikemaskini",
  "Can not Add the Record":"Tidak dapat Tambah Rekod",
  "Account Code -Debit":"Kod Akaun - Debit",
  "Account Code - Credit":"Kod Akaun - Kredit",
  "Pension":"Pencen",
  "Locked":"Terkunci",
  "Show":"Papar",
  "Saas Code":"Kod Saas",
  "Font Color":"Warna Fon",
  "Font Style":"Gaya Fon",
  "Hexa Code Color Background":"Warna Latar Belakang Kod Hex",
  "normal":"biasa",
  "italic":"italik",
  "oblique":"oblik",
  "Reserved":"Ditempah",
  "Error":"Ralat",
  "mom":"ibu",
  "dad":"bapa",
  "Point": "Mata",
  "Add Payslip Header,Footer,organization logo,ID Template":"Tambah Kepala Slip Gaji, Kaki, logo organisasi, Templat ID",
  "Add on Note":"Tambah pada Nota",
  "Workplan Evaluation":"Penilaian Pelan Kerja",
  "Hr Letters":"Surat HR",
  "Letter ":"Surat",
  "HR Admin Payroll Processes":"Proses Penggajian Admin HR",
  "Payroll Line Entry Record":"Rekod Kemasukan Baris Gaji",
  "Closed Payroll Line Entry":"Kemasukan Baris Gaji Ditutup",
  "Cancelled Payroll Line Entry":"Kemasukan Baris Gaji Dibatalkan",
  "Employee Monthly Target":"Sasaran Bulanan Pekerja",
  "Employee Log Activity":"Aktiviti Log Pekerja",
  "Employee Summary Target Activity":"Aktiviti Sasaran Ringkasan Pekerja",
  "Dependant Import":"Import Tanggungan",
  "Leave Import":"Import Cuti",
  "Assets Import":"Import Aset",
  "Salary Import":"Import Gaji",
  "KPI of completed Project":"KPI Projek yang Selesai",
  "KPI Attendance Employee":"KPI Kehadiran Pekerja",
  "KPI Attendance Organization":"KPI Kehadiran Organisasi",
  "KPI Attendance Organization Listing":"Senarai KPI Kehadiran Organisasi",
  "Groups CheckIN":"Daftar Masuk Kumpulan",
  "Groups Attendance Logs":"Log Kehadiran Kumpulan",
  "Project Groups":"Kumpulan Projek",
  "Use this Access Code For Office Entry":"Gunakan Kod Akses ini Untuk Masuk Pejabat",
  "Workplan":"Pelan Kerja",
  "Goal":"Matlamat",
  "Recommendations":"Syor",
  "Feedback":"Maklum Balas",
  "HR Actions":"Tindakan HR",
  "Links":"Pautan",
  "Target":"Sasaran",
  "Activity":"Aktiviti",
  "Evolution":"Evolusi",
  "Overtime":"Lebih Masa",
  "Employee Overtime Request":"Permintaan Lebih Masa Pekerja",
  "Attendance Import":"Import Kehadiran",
  "Exchange Rate":"Kadar Pertukaran",
  "Cost":"Kos",
  "Closed":"Ditutup",
  "this":"ini",
  "OFF":"TUTUP",
  "No Shows":"Tidak Hadir",
  "Total Performance":"Prestasi Keseluruhan",
  "Applicant":"Pemohon",
  "Resume":"Resume",
  "Close Date":"Tarikh Tutup",
  "Job Id":"ID Kerja",
  "No Of Candidates Applied":"Bilangan Calon Memohon",
  "Number Of":"Bilangan",
  "Minimum":"Minimum",
  "Experience":"Pengalaman",
  "Load":"Muat",
  "Send":"Hantar",
  "Price":"Harga",
  "Discounted":"Didiskaun",
  "SKU":"SKU",
  "Brand":"Jenama",
  "Top List":"Senarai Teratas",
  "Order":"Pesanan",
  "For e.g.":"Contohnya",
  "HR Letters":"Surat HR",
  "HR Letter Fields":"Ruangan Surat HR",
  "IN": "MASUK",
  "OUT": "KELUAR",
  "Appointment":"Temujanji",
  "Valid":"Sah",
  "CheckIN":"Daftar Masuk",
  "Reported":"Dilaporkan",
  "Created On":"Dicipta Pada",
  "Media":"Media",
  "Photo":"Foto",
  "Holiday":"Cuti/Hari Kelepasan",
  "Head":"Ketua",
  "Privilege":"Keistimewaan",
  "Module":"Modul",
  "Delete":"Padam",
  "Activity Type":"Jenis Aktiviti",
  "Activity Status":"Status Aktiviti",
  "Activity Valuation %":"% Penilaian Aktiviti",
  "Attendance Remarks":"Catatan Kehadiran",
  "Maximum":"Maksimum",
  "Valuation":"Penilaian",
  "Exchange":"Pertukaran",
  "User":"Pengguna",
  "IP":"IP",
  "Operation":"Operasi",
  "Affected":"Terjejas",
  "Table":"Jadual",
  "Rows":"Baris",
  "Timestamp":"Cap Masa",
  "Payroll Process":"Proses Penggajian",
  "Remarks":"Catatan",
  "To Date":"Hingga Tarikh",
  "Only Salary":"Gaji Sahaja",
  "Next":"Seterusnya",
  "Be Processed":"Diproses",
  "Early Leaving":"Keluar Awal",
  "Time Late":"Masa Lewat",
  "Done":"Selesai",
  "Gross":"Kasar",
  "Pay":"Bayar",
  "Unpaid":"Tanpa Gaji",
  "Dependant":"Tanggungan",
  "Seniority":"Senioriti",
  "Advanced":"Lanjutan",
  "Net":"Bersih",
  "Children":"Kanak-kanak",
  "Ticket":"Tiket",
  "Msg Send Successfully":"Mesej Berjaya Dihantar",
  "Msg Not Send Successfully":"Mesej Gagal Dihantar",
};